module.exports = __webpack_public_path__ + "img/Qcard.9afecfc2.jpg";